import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Card, CardBody, Col, Row, Table } from "reactstrap";
import {
  GET_RP_ACTIVITY_ENTRY,
  GET_RP_ACTIVITY_EXIT,
  GET_RP_SUPPLY_DEMAND_ENTRY,
  GET_RP_SUPPLY_DEMAND_EXIT,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";

import BarChartTodayPlanDaily from "./BarChartTodayPlanDaily";
import BarChartTodayPlanWeekly from "./BarChartTodayPlanWeekly";
import PropTypes from "prop-types";
import SupplyDemandPlan from "./SupplyDemandPlan";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";
import moment from "moment";

function SectionTodayPlan(props) {
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(number.replaceAll("+", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(number.replaceAll("-", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const dispatch = useDispatch();
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [total, setTotal] = useState({});

  const [dataListMerge, setDataListMerge] = useState({
    entryDataList: [],
    exitDataList: [],
    dtEntry: [],
    dtExit: [],
  });

  const getColumnEntry = () => post(GET_RP_SUPPLY_DEMAND_ENTRY, {});
  const getColumnExit = () => post(GET_RP_SUPPLY_DEMAND_EXIT, {});

  const generateRow = () => {
    let entryList = [
      ...dataListMerge.entryDataList.filter(
        row => row.SUPPLYDEMAND_SHOW == true
      ),
    ];
    let exitList = [
      ...dataListMerge.exitDataList.filter(
        row => row.SUPPLYDEMAND_SHOW == true
      ),
    ];
    let rowData = [];

    entryList.map(row => {
      let obj = {};
      for (const [key, value] of Object.entries(row)) {
        obj[`ENTRY_${key}`] = value;
      }

      let prevData = rowData.find(
        prev => prev.SUPPLYDEMAND_NAME == obj.ENTRY_SUPPLYDEMAND_NAME
      );
      if (prevData) {
        rowData = rowData.map(prev => {
          if (prev.SUPPLYDEMAND_NAME == obj.ENTRY_SUPPLYDEMAND_NAME) {
            return { ...prev, ...obj };
          }
          return prev;
        });
      } else {
        obj.SUPPLYDEMAND_NAME = row.SUPPLYDEMAND_NAME;
        rowData.push(obj);
      }
    });
    exitList.map(row => {
      let obj = {};
      for (const [key, value] of Object.entries(row)) {
        obj[`EXIT_${key}`] = value;
      }

      let prevData = rowData.find(
        prev => prev.SUPPLYDEMAND_NAME == obj.EXIT_SUPPLYDEMAND_NAME
      );

      if (prevData) {
        rowData = rowData.map(prev => {
          if (prev.SUPPLYDEMAND_NAME == obj.EXIT_SUPPLYDEMAND_NAME) {
            return { ...prev, ...obj };
          }
          return prev;
        });
      } else {
        obj.SUPPLYDEMAND_NAME = row.SUPPLYDEMAND_NAME;
        rowData.push(obj);
      }
    });
    rowData = rowData.map((row, index) => ({ ...row, row: index }));
    let tempRowData = addFieldToModelDeviceList(rowData);
    // console.log(tempRowData)
    if (tempRowData) setModelDeviceList([...tempRowData]);
  };

  useEffect(() => {
    // console.log(props.summaryReportPid)
    fetchData();
  }, [props.summaryReportPid]);
  useEffect(() => {
    if (
      dataListMerge.entryDataList.length > 0 ||
      dataListMerge.exitDataList.length > 0
    ) {
      // console.log(3)
      generateRow();
    }
  }, [dataListMerge]);

  const fetchData = async () => {
    function compare(a, b) {
      if (a.SUPPLYDEMAND_ORDER < b.SUPPLYDEMAND_ORDER) {
        return -1;
      }
      if (a.SUPPLYDEMAND_ORDER > b.SUPPLYDEMAND_ORDER) {
        return 1;
      }
      return 0;
    }

    dispatch(loadingAction.showLoading());
    try {
      let [entry, exit, dtEntry, dtExit] = await Promise.all([
        getColumnEntry(),
        getColumnExit(),
        post(GET_RP_ACTIVITY_ENTRY, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
        post(GET_RP_ACTIVITY_EXIT, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
      ]);
      // console.log(entry,exit,dtEntry,dtExit)
      setDataListMerge({
        entryDataList: entry.data.rpSupplyDemandEntryList
          .sort(compare)
          .filter(obj => obj.SUPPLYDEMAND_SHOW == true)
          .map((obj, index) => ({
            ...obj,
            ROW: index + 1,
          })),
        exitDataList: exit.data.rpSupplyDemandExitList
          .sort(compare)
          .filter(obj => obj.SUPPLYDEMAND_SHOW == true)
          .map((obj, index) => ({
            ...obj,
            ROW: index + 1,
          })),
        dtEntry: dtEntry.data.rpActivityEntryList,
        dtExit: dtExit.data.rpActivityExitList,
      });
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const addFieldToModelDeviceList = rowList => {
    let dataModel = {
      PID: "",
      SUPPLYDEMAND_PID: "",
      SUPPLYDEMAND_ORDER: 0,
      SUPPLYDEMAND_NAME: "",
      ACTIVITY_PLAN_ENTRY: "",
      ACTIVITY_ACTUAL_ENTRY: "",
      SUPPLY_DIFF_ENTRY: "",
      ACTIVITY_PLAN_EXIT: "",
      ACTIVITY_ACTUAL_EXIT: "",
      DEMAND_DIFF_EXIT: "",
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      // console.log(dataList)
      let mergeEntryCell = [];
      let mergeExitCell = [];
      let notInList = [];
      dataListMerge.entryDataList.map((row, index) => {
        notInList.push(row.PID);
        dataListMerge.entryDataList
          .filter(x => notInList.indexOf(x.PID) == -1)
          .map(e => {
            if (
              row.PID != e.PID &&
              row.SUPPLYDEMAND_SET == e.SUPPLYDEMAND_SET &&
              row.SUPPLYDEMAND_ZONE == e.SUPPLYDEMAND_ZONE
            ) {
              let preventData = mergeEntryCell.find(
                obj => obj.ENTRY_group == index
              );
              notInList.push(e.PID);
              if (preventData) {
                mergeEntryCell = [
                  ...mergeEntryCell.map(prev => {
                    if (prev.ENTRY_group == index) {
                      prev.ENTRY_subPid = [...prev.ENTRY_subPid, e.PID];
                    }
                    return prev;
                  }),
                ];
              } else {
                mergeEntryCell.push({
                  ENTRY_group: index,
                  ENTRY_mainPid: row.PID,
                  ENTRY_subPid: [e.PID],
                });
              }
            }
          });
      });

      dataListMerge.exitDataList.map((row, index) => {
        notInList.push(row.PID);
        dataListMerge.exitDataList
          .filter(x => notInList.indexOf(x.PID) == -1)
          .map(e => {
            if (
              row.PID != e.PID &&
              row.SUPPLYDEMAND_ZONE == e.SUPPLYDEMAND_ZONE &&
              row.SUPPLYDEMAND_SET1 == e.SUPPLYDEMAND_SET1 &&
              row.SUPPLYDEMAND_OVERHEAD1 == e.SUPPLYDEMAND_OVERHEAD1 &&
              row.SUPPLYDEMAND_DIVISOR1 == e.SUPPLYDEMAND_DIVISOR1 &&
              row.SUPPLYDEMAND_SET2 == e.SUPPLYDEMAND_SET2 &&
              row.SUPPLYDEMAND_OVERHEAD2 == e.SUPPLYDEMAND_OVERHEAD2 &&
              row.SUPPLYDEMAND_DIVISOR2 == e.SUPPLYDEMAND_DIVISOR2
            ) {
              // console.log(2)
              let preventData = mergeExitCell.find(
                obj => obj.EXIT_group == index
              );
              notInList.push(e.PID);
              if (preventData) {
                mergeExitCell = [
                  ...mergeExitCell.map(prev => {
                    if (prev.EXIT_group == index) {
                      prev.EXIT_subPid = [...prev.EXIT_subPid, e.PID];
                    }
                    return prev;
                  }),
                ];
              } else {
                mergeExitCell.push({
                  EXIT_group: index,
                  EXIT_mainPid: row.PID,
                  EXIT_subPid: [e.PID],
                });
              }
            }
          });
      });
      // console.log(mergeExitCell);
      let modelList = [];
      rowList.map(objRow => {
        // console.log(objRow,dataListMerge.dtEntry)
        let dataEntry = dataListMerge.dtEntry.find(
          row => row.SUPPLYENTRY_PID == objRow.ENTRY_PID
        );
        let dataExit = dataListMerge.dtExit.find(
          row => row.DEMANDEXIT_PID == objRow.EXIT_PID
        );
        // console.log(dataEntry)
        let mergeEntry = mergeEntryCell.find(
          row =>
            objRow.ENTRY_PID == row.ENTRY_mainPid ||
            row.ENTRY_subPid.indexOf(objRow.ENTRY_PID) >= 0
        );
        let mergeExit = mergeExitCell.find(
          row =>
            objRow.EXIT_PID == row.EXIT_mainPid ||
            row.EXIT_subPid.indexOf(objRow.EXIT_PID) >= 0
        );
        // console.log(mergeExit);
        modelList.push({
          ...dataModel,
          ...objRow,
          ...dataEntry,
          ...dataExit,
          ENTRY_groups: mergeEntry ? mergeEntry.ENTRY_group : null,
          ENTRY_rowspan: mergeEntry ? mergeEntry.ENTRY_subPid.length + 1 : null,
          EXIT_groups: mergeExit ? mergeExit.EXIT_group : null,
          EXIT_rowspan: mergeExit ? mergeExit.EXIT_subPid.length + 1 : null,
        });
      });
      // console.log(modelList);
      rowList.map(objRow => ({ ...dataModel, ...objRow }));
      let totalRow = modelList.reduce(function (accumulator, item) {
        accumulator["ACTIVITY_PLAN_ENTRY"] =
          (accumulator["ACTIVITY_PLAN_ENTRY"] || 0) +
          item["ACTIVITY_PLAN_ENTRY"];
        accumulator["ACTIVITY_ACTUAL_ENTRY"] =
          (accumulator["ACTIVITY_ACTUAL_ENTRY"] || 0) +
          item["ACTIVITY_ACTUAL_ENTRY"];
        accumulator["ACTIVITY_PLAN_EXIT"] =
          (accumulator["ACTIVITY_PLAN_EXIT"] || 0) + item["ACTIVITY_PLAN_EXIT"];
        accumulator["ACTIVITY_ACTUAL_EXIT"] =
          (accumulator["ACTIVITY_ACTUAL_EXIT"] || 0) +
          item["ACTIVITY_ACTUAL_EXIT"];
        return { ...dataModel, ...accumulator, SUPPLYDEMAND_NAME: "Total" };
      }, {});
      let entryReduce = mergeEntryCell.reduce(
        (total, item) => {
          let temp = dataListMerge.dtEntry.find(
            row => item.ENTRY_subPid.indexOf(row.SUPPLYENTRY_PID) >= 0
          );
          if (temp) {
            total.ACTIVITY_PLAN_ENTRY =
              total.ACTIVITY_PLAN_ENTRY + temp.ACTIVITY_PLAN_ENTRY;
            total.ACTIVITY_ACTUAL_ENTRY =
              total.ACTIVITY_ACTUAL_ENTRY + temp.ACTIVITY_ACTUAL_ENTRY;
          }
          return { ...total };
        },
        { ACTIVITY_PLAN_ENTRY: 0, ACTIVITY_ACTUAL_ENTRY: 0 }
      );
      let exitReduce = mergeExitCell.reduce(
        (total, item) => {
          let temp = dataListMerge.dtExit.find(
            row => item.EXIT_subPid.indexOf(row.DEMANDEXIT_PID) >= 0
          );
          if (temp) {
            total.ACTIVITY_PLAN_EXIT =
              total.ACTIVITY_PLAN_EXIT + temp.ACTIVITY_PLAN_EXIT;
            total.ACTIVITY_ACTUAL_EXIT =
              total.ACTIVITY_ACTUAL_EXIT + temp.ACTIVITY_ACTUAL_EXIT;
          }
          return { ...total };
        },
        { ACTIVITY_PLAN_EXIT: 0, ACTIVITY_ACTUAL_EXIT: 0 }
      );
      totalRow.ACTIVITY_PLAN_ENTRY =
        totalRow.ACTIVITY_PLAN_ENTRY - entryReduce.ACTIVITY_PLAN_ENTRY;

      totalRow.ACTIVITY_ACTUAL_ENTRY =
        totalRow.ACTIVITY_ACTUAL_ENTRY - entryReduce.ACTIVITY_ACTUAL_ENTRY;

      totalRow.ACTIVITY_PLAN_EXIT =
        totalRow.ACTIVITY_PLAN_EXIT - exitReduce.ACTIVITY_PLAN_EXIT;

      totalRow.ACTIVITY_ACTUAL_EXIT =
        totalRow.ACTIVITY_ACTUAL_EXIT - exitReduce.ACTIVITY_ACTUAL_EXIT;
      // console.log(totalRow)
      // console.log(totalRow.SUPPLY_PLAN_ENTR,)
      setTotal(totalRow);
      //   console.log(totalRow)
      return [...modelList, totalRow];
    }
  };

  return (
    <Row>
      {/* <Col sm="12">
        <Card style={{ backgroundColor: "#1E2446", borderRadius: "30px" }}>
          <CardBody> */}
      {/* <Row>
              <Col sm="12"> */}
      <Row className="mt-0">
        <Col sm="12">
          <h5
            className="mb-0 sm-0"
            style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
          >
            Today Plan
          </h5>
        </Col>
        {/* <Col sm="6">
          <h5
            className="mb-0 sm-0 d-flex align-items-center justify-content-end"
            style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
          >
            Gas Day : {moment(props.date).locale("en").format("DD MMM YYYY")}

          </h5>
        </Col> */}
      </Row>

      <Row className="mt-2">
        <hr />
      </Row>

      {/* <Row> */}
      {/* <Col sm="7" className="mt-0"> */}
      <div className="d-flex dashboard-content-body">
        <div className="d-flex flex-column" style={{ flex: 1.5 }}>
          <div className="d-flex" style={{ flex: 1, minWidth: 5 }}>
            <div style={{ minWidth: '17%' }} className="mt-0">
              <Table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#556ee678",
                        color: "#FEF6AA",
                        textAlign: "center",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Entry (Weekly Plan)
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: "1.5vw",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td>{numberFormat(total.ACTIVITY_PLAN_ENTRY, 0)}</td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#FEF6AA",
                        textAlign: "center",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Exit (Weekly Plan)
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: "1.5vw",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td>{numberFormat(total.ACTIVITY_PLAN_EXIT, 0)}</td>
                  </tr>
                </tbody>
              </Table>
            </div>

            <div style={{ minWidth: '83%', position: 'relative', margin: 'auto', height: '90%' }} className="mt-0">
              <BarChartTodayPlanWeekly
                summaryReportPid={props.summaryReportPid}
                date={props.date}
                modelDeviceList={modelDeviceList}
              />
            </div>
          </div>

          <div className="d-flex" style={{ flex: 1, margin: 5 }}>
            <div style={{ minWidth: '17%' }} className="mt-0">
              <Table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#2c64b6a8",
                        color: "#FEF6AA",
                        textAlign: "center",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Entry (Daily Plan)
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: "1.5vw",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td>
                      {numberFormat(total.ACTIVITY_ACTUAL_ENTRY, 0)}
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#2c64b6a8",
                        color: "#FEF6AA",
                        textAlign: "center",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Exit (Daily Plan)
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: "1.5vw",
                    fontWeight: "bold",
                  }}
                >
                  <tr>
                    <td>
                      {numberFormat(total.ACTIVITY_ACTUAL_EXIT, 0)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <div style={{ minWidth: '83%', position: 'relative', margin: 'auto', height: '90%' }} className="mt-0">
              <BarChartTodayPlanDaily
                summaryReportPid={props.summaryReportPid}
                date={props.date}
                modelDeviceList={modelDeviceList}
              />
            </div>
          </div>
        </div>
        {/* </Col> */}
        {/* <Col sm="5" style={{ borderLeft: "2px solid #4A5576" }}> */}

        <div
          // className="d-flex flex-column"
          style={{ width: "70vh" }} //flex: 1.4,width: "1000px"
        >
          <SupplyDemandPlan
            summaryReportPid={props.summaryReportPid}
            date={props.date}
            modelDeviceList={modelDeviceList}
          />
        </div>

        {/* </Col> */}
      </div>
      {/* </Row> */}
      {/* </Col>
            </Row> */}
      {/* </CardBody>
        </Card>
      </Col> */}
    </Row>
  );
}

SectionTodayPlan.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default SectionTodayPlan;
